<template>
    <div>
        <v-col cols="12">
            <b-alert :message="t('pharmacy-sites::hint.message')"></b-alert>
            <h2 class="mt-4 mb-0">{{ t('pharmacy-sites::page.title.pharmacy_sites') }}</h2>
            <pharmacy-site-data-table :list-route="listRoute"></pharmacy-site-data-table>
        </v-col>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        listRoute: {
            type: String,
            required: true,
        },
    },
    data() {
        return {};
    },
    methods: {},
};
</script>
